// extracted by mini-css-extract-plugin
export default {"movementWrapper":"styles_movementWrapper__Bonbi"};